import objectPath from 'object-path';

const mapPlanParcelMeta = (planParcels = [], volFolio = {}) => {
  const pp = planParcels[0];

  const planParcelDisplay = pp
    ? `${pp.planType}${pp.planNumber} ${pp.parcelType} ${pp.parcelTypeDescription} ${pp.parcelNumber}`
    : '';

  const volFolioDisplay = volFolio
    ? `${volFolio.volFolPrefix}${volFolio.volume}/${volFolio.folio}`
    : '';

  return [ volFolioDisplay, planParcelDisplay ];
};

const getPlanParcelGlobalX = (order) => {
  const volFolio = objectPath.get(order.globalx_meta, 'volumeFolio');
  const planParcels = objectPath.get(order.globalx_meta, '_embedded.planParcels') || [];

  return mapPlanParcelMeta(planParcels, volFolio);
};

export const getCTParcel = (order = {}) => {
  if (Object.getOwnPropertyNames(order.meta || {}).length) {
    return mapPlanParcelMeta(order.meta.planParcels, order.meta.volumeFolio);
  }

  if (order.globalx_meta) {
    return getPlanParcelGlobalX(order);
  }

  return [ order.address_ct, order.address_plan_lot_section ] 
}

export default getCTParcel;
